import { useEffect, useState } from "react";
import api from "../lib/api";
import {
  SERVICE_OFFERINGS,
  INDUSTRIES_WE_SERVE,
  WHY_KALPAVRIKSHA,
  SERVICES,
} from "../data/serviceOfferings";
import { PACKAGES as FALLBACK_PACKAGES } from "../data/content";

const FALLBACK = {
  offerings: SERVICE_OFFERINGS,
  industries: INDUSTRIES_WE_SERVE,
  why_choose: WHY_KALPAVRIKSHA,
  home_cards: SERVICES,
  packages: FALLBACK_PACKAGES,
};

export function useSiteServices() {
  const [data, setData] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/site/services")
      .then((r) => {
        if (!cancelled && r.data) {
          setData({
            offerings: r.data.offerings?.length ? r.data.offerings : FALLBACK.offerings,
            industries: r.data.industries?.length ? r.data.industries : FALLBACK.industries,
            why_choose: r.data.why_choose?.length ? r.data.why_choose : FALLBACK.why_choose,
            home_cards: r.data.home_cards?.length ? r.data.home_cards : FALLBACK.home_cards,
            packages: r.data.packages?.length ? r.data.packages : FALLBACK.packages,
          });
        }
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { ...data, loading };
}

export { FALLBACK as FALLBACK_SITE_SERVICES };
